/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CombinationDto } from './combinationDto';
import { ImplementDataDto } from './implementDataDto';
import { GeometryIdDto } from './geometryIdDto';
import { ArrivalDataDto } from './arrivalDataDto';
import { EmployeeDataDto } from './employeeDataDto';
import { EmployeeIdDto } from './employeeIdDto';
import { MachineDataDto } from './machineDataDto';

export interface OperationV2Dto {
  arrivalData?: ArrivalDataDto;
  combinations?: Array<CombinationDto>;
  dataArchived?: boolean;
  dataUpdating?: boolean;
  employeeData?: Array<EmployeeDataDto>;
  employeeDataGeometry?: Array<EmployeeDataDto>;
  employees?: Array<EmployeeIdDto>;
  foxOperationId?: string;
  geometry?: GeometryIdDto;
  id?: number;
  implementData?: Array<ImplementDataDto>;
  implementDataGeometry?: Array<ImplementDataDto>;
  jobIds?: Array<number>;
  machineData?: Array<MachineDataDto>;
  machineDataGeometry?: Array<MachineDataDto>;
  name?: string;
  processId?: number;
  start?: string;
  state?: string;
  stop?: string;
}
